import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CommandBase } from '../../model/command';
import { CommandDispatcher } from '../../service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../service/command/command-handler-resolver.service';

function isObservable(obj): boolean {
  return !!obj && typeof obj.subscribe === 'function';
}

@Directive()
export class CommandController implements OnDestroy {
  constructor(
    protected readonly commandDispatcher: CommandDispatcher,
    private _handlerResolver: CommandHandlerResolver
  ) {
    this._subscriptions = new Subscription();
    if (commandDispatcher && commandDispatcher.commands) {
      this._subscriptions.add(
        commandDispatcher.commands.pipe(filter(command => this.canExecute(command))).subscribe(command => this.execute(command))
      );
    }
  }

  public readonly contextId: string = typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : Array.from(crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, '0'))
        .join('')
        .replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');

  private readonly _subscriptions: Subscription;
  private _resultSub: Subscription;

  protected AddSubscription(subscription: Subscription): void {
    if (!subscription) {
      throw new Error('Null reference. Object not set.');
    }

    this._subscriptions.add(subscription);
  }

  protected executedWithResult(result: boolean, command: CommandBase): void {}

  canExecute(command: CommandBase): boolean {
    if (command.contextId && command.contextId !== this.contextId) {
      return false;
    }

    if (!this._handlerResolver) {
      return false;
    }
    if (this._handlerResolver.canResolve(command)) {
      var handler = this._handlerResolver.resolve(command);
      return handler.canExecute(command);
    }
    return false;
  }

  execute(command: CommandBase): void {
    var handler = this._handlerResolver.resolve(command);
    this.clearSubscriptions();
    this._resultSub = new Subscription();
    let result = handler.execute(command);
    this._resultSub.add(
      result.subscribe((value: boolean | void) => {
        if (typeof value === typeof true) {
          this.executedWithResult(<boolean>value, command);
        }
      })
    );
  }

  private clearSubscriptions() {
    if (this._resultSub && !this._resultSub.closed) this._resultSub.unsubscribe();
    this.clearAdditionalSubscriptions();
  }

  protected clearAdditionalSubscriptions() {}

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
    this.clearSubscriptions();
  }
}
